import { render } from "./ParentLogin.vue?vue&type=template&id=29371b0a"
import script from "./ParentLogin.vue?vue&type=script&lang=js"
export * from "./ParentLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__